import {
  Box,
  Divider,
  FormControl,
  FormControlLabel,
  InputLabel,
  MenuItem,
  Select,
  Switch,
  Typography,
  useTheme,
} from '@mui/material';
import { Trans, useTranslation } from 'react-i18next';
import React, { Dispatch, FC, SetStateAction, useContext } from 'react';
import { AlertManagement } from '../../shared/interfaces/IAlerts';
import { AuthContext } from '../../providers/AuthProvider';

interface Props {
  newAlert: AlertManagement;
  updatedAlert: AlertManagement;
  onChangeNew: Dispatch<SetStateAction<AlertManagement>>;
  onChangeUpdated: Dispatch<SetStateAction<AlertManagement>>;
}
const AlertConfigurator: FC<Props> = ({ newAlert, updatedAlert, onChangeNew, onChangeUpdated }) => {
  const theme = useTheme();
  const { t } = useTranslation();
  const { hasRole } = useContext(AuthContext);

  return (
    <>
      <Box sx={{ display: 'flex', flexDirection: 'column', mt: theme.spacing(2) }}>
        <Typography
          variant="h5"
          sx={{ mt: 2 }}
        >
          {t('alerts')}
        </Typography>
        <Divider />
        <Typography
          variant="body2"
          sx={{ fontWeight: 700, mt: theme.spacing(2) }}
        >
          {t('settings_for_alerts')}
        </Typography>
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'column', mt: theme.spacing(2) }}>
        <FormControlLabel
          control={
            <Switch
              checked={newAlert.active}
              onChange={(event) => {
                onChangeNew((prev) => ({ ...prev, active: event.target.checked }));
              }}
            ></Switch>
          }
          label={t('new_ratings')}
        />
        <FormControl
          size="small"
          sx={{ mt: theme.spacing(2) }}
        >
          <InputLabel id="alert-select-label">{t('notification_interval')}</InputLabel>
          <Select
            labelId="alert-select-label"
            value={newAlert.interval}
            onChange={(event) => {
              onChangeNew((prev) => ({ ...prev, interval: event.target.value as number }));
            }}
            label={t('notification_interval')}
          >
            {newAlert.options.map((option) => (
              <MenuItem
                key={option.id}
                value={option.id}
              >
                <Trans t={t}>{option.name.toLowerCase()}</Trans>
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
      {hasRole('can-use-alerts-updates') && (
        <Box sx={{ display: 'flex', flexDirection: 'column', mt: theme.spacing(2) }}>
          <FormControlLabel
            control={
              <Switch
                checked={updatedAlert.active}
                onChange={(event) => {
                  onChangeUpdated((prev) => ({ ...prev, active: event.target.checked }));
                }}
              ></Switch>
            }
            label={t('updated_ratings')}
          />
          <FormControl
            size="small"
            sx={{ mt: theme.spacing(2) }}
          >
            <InputLabel id="alert-select-label">{t('notification_interval')}</InputLabel>
            <Select
              labelId="alert-select-label"
              value={updatedAlert.interval}
              onChange={(event) => {
                onChangeUpdated((prev) => ({ ...prev, interval: event.target.value as number }));
              }}
              label={t('notification_interval')}
            >
              {updatedAlert.options.map((option) => (
                <MenuItem
                  key={option.id}
                  value={option.id}
                >
                  <Trans t={t}>{option.name.toLowerCase()}</Trans>
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
      )}
    </>
  );
};

export default AlertConfigurator;
